// Core
import { takeEvery, all, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// Workers
import { 
    fetchDriverSalaryAdjustmentsWorker,
    fetchDriverSalaryAdjustmentsWorkerEdit,
    fetchDriverSalaryAdjustmentsWorkerInfo,
    fetchDriverSalaryAdjustmentsWorkerCreate,
    fetchDriverSalaryAdjustmentsWorkerDelete,

    fetchDriverSalaryAdjustmentsWorkerDetail,
    fetchDriverSalaryAdjustmentsWorkerDetailCreate,
    fetchDriverSalaryAdjustmentsWorkerDetailDelete,
    fetchDriverSalaryAdjustmentsWorkerDetailEdit,
    fetchDriverSalaryAdjustmentsWorkerDetailOne,
 } from './worker';
import {
    driverSalaryAdjustmentsCreate,
    driverSalaryAdjustmentsDelete,
    driverSalaryAdjustmentsDetail,
    driverSalaryAdjustmentsEdit,
    driverSalaryAdjustmentsInfo,
    
    driverSalaryAdjustmentsDetailCreate,
    driverSalaryAdjustmentsDetailDelete,
    driverSalaryAdjustmentsDetailEdit,
    driverSalaryAdjustmentsDetailList,
    driverSalaryAdjustmentsDetailOne,

} from '../actions';


function* watchFetchDriverSalaryAdjustments(): SagaIterator {
    yield takeEvery(driverSalaryAdjustmentsDetail.async, fetchDriverSalaryAdjustmentsWorker);
}
function* watchFetchDriverSalaryAdjustmentsCreate(): SagaIterator {
    yield takeEvery(driverSalaryAdjustmentsCreate.async, fetchDriverSalaryAdjustmentsWorkerCreate);
}
function* watchFetchDriverSalaryAdjustmentsInfo(): SagaIterator {
    yield takeEvery(driverSalaryAdjustmentsInfo.async, fetchDriverSalaryAdjustmentsWorkerInfo);
}
function* watchFetchDriverSalaryAdjustmentsEdit(): SagaIterator {
    yield takeEvery(driverSalaryAdjustmentsEdit.async, fetchDriverSalaryAdjustmentsWorkerEdit);
}
function* watchFetchDriverSalaryAdjustmentsDelete(): SagaIterator {
    yield takeEvery(driverSalaryAdjustmentsDelete.async, fetchDriverSalaryAdjustmentsWorkerDelete);
}

//detail
function* watchFetchDriverSalaryAdjustmentsDetailOne(): SagaIterator {
    yield takeEvery(driverSalaryAdjustmentsDetailOne.async, fetchDriverSalaryAdjustmentsWorkerDetailOne);
}
function* watchFetchDriverSalaryAdjustmentsDetail(): SagaIterator {
    yield takeEvery(driverSalaryAdjustmentsDetailList.async, fetchDriverSalaryAdjustmentsWorkerDetail);
}
function* watchFetchDriverSalaryAdjustmentsCreateDetail(): SagaIterator {
    yield takeEvery(driverSalaryAdjustmentsDetailCreate.async, fetchDriverSalaryAdjustmentsWorkerDetailCreate);
}
function* watchFetchDriverSalaryAdjustmentsEditDetail(): SagaIterator {
    yield takeEvery(driverSalaryAdjustmentsDetailEdit.async, fetchDriverSalaryAdjustmentsWorkerDetailEdit);
}
function* watchFetchDriverSalaryAdjustmentsDeleteDetail(): SagaIterator {
    yield takeEvery(driverSalaryAdjustmentsDetailDelete.async, fetchDriverSalaryAdjustmentsWorkerDetailDelete);
}

export function* watchDriverSalaryAdjustments(): SagaIterator {
    yield all([
        call(watchFetchDriverSalaryAdjustments),
        call(watchFetchDriverSalaryAdjustmentsCreate),
        call(watchFetchDriverSalaryAdjustmentsInfo),
        call(watchFetchDriverSalaryAdjustmentsEdit),
        call(watchFetchDriverSalaryAdjustmentsDelete),

        call(watchFetchDriverSalaryAdjustmentsDetail),
        call(watchFetchDriverSalaryAdjustmentsCreateDetail),
        call(watchFetchDriverSalaryAdjustmentsEditDetail),
        call(watchFetchDriverSalaryAdjustmentsDeleteDetail),
        call(watchFetchDriverSalaryAdjustmentsDetailOne),
    ]);
}